<template>
  <div class="container">
    <!-- Account Title -->
    <div class="row">
      <div class="col-md-12 acctTitle"
         :style="{ fontSize: fonts.font24 + 'px' }">{{ searchHead }}</div>
    </div>

    <div v-if="showSaveList === false"> <!-- Start of normal form -->
      <!-- ********************************************************
      Search Range Box
      ********************************************************* -->
      <div class="row">
        <div class="container topBox">
          <div class="row">
            <div class="col-md-12" :style="{ fontSize: fonts.font24 + 'px' }">Search Range</div>
          </div>

          <div class="row">
            <div class="col-md-12" :style="{ border: 'solid 4px ' + tqColor }">
              <span>Most Recent</span>
              <input id="recentCount"
                     autocomplete="off"
                     autocorrect="off"
                     autocapitalize="off"
                     spellcheck="false"
                     aria-label="Transaction Count"
                     type="text"
                     v-model="tCount"
                     @focus = "tcGotFocus"
                     @change = "tcChanged"
                     required
                     placeholder="count" />
              <span>Transactions</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">** OR **</div>
          </div>
          <div class="row">
            <div class="col-md-12 container" :style="{ border: 'solid 4px ' + drColor }">
              <div class="row">
                <div class="col-md-2"></div>
                <b-form-select class="dropx col-md-8 dropper"
                               v-model="selected"
                               :options="options"
                               @change="customize">
                </b-form-select>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2"></div>
                <table class="col-md-4">
                  <th class="dateHeader">Oldest Date:</th>
                  <tr>
                    <el-date-picker
                      class="datePicker"
                      v-model="startDate"
                      format="MM/dd/yyyy"
                      type="date"
                      :editable="false"
                      :clearable="false"
                      @change="oldChanged"
                      size="mini"
                      placeholder="Start Date">
                    </el-date-picker>
                  </tr>
                </table>

                <table class="col-md-4">
                  <th class="dateHeader">Newest Date:</th>
                  <tr>
                    <el-date-picker
                      class="datePicker"
                      v-model="endDate"
                      format="MM/dd/yyyy"
                      type="date"
                      :editable="false"
                      :clearable="false"
                      @change="newChanged"
                      size="mini"
                      placeholder="End Date">
                    </el-date-picker>
                  </tr>
                </table>
              </div>
            </div>
            <!-- ********************************************************
            Top Buttons
            ********************************************************* -->
            <div class="col-md-12">
              <div style="height: 10px;"></div>
              <b-radio-group class="rGroup" v-model="direction">
                <b-radio
                  class="rItem"
                  value="rev"
                  :style="{ fontSize: fonts.font14 + 'px'}"
                >Reverse Order (Newest Date First)</b-radio>
                <br />
                <div style="height: 10px;"></div>
                <b-radio
                  class="rItem"
                  value="fwd"
                  :style="{ fontSize: fonts.font14 + 'px'}"
                >Forward Order (Oldest Date First)</b-radio>
              </b-radio-group>
              <div style="height: 10px;"></div>
              <button
                v-if="askSaveName === false"
                class="btn btn-success lowBtn"
                @click="clkSearch"
                type="button">Search</button>
            </div>
            <div class="col-md-2"></div>
          </div>
        </div>
      </div>

      <!-- ********************************************************
      Search Parameters Box
      ********************************************************* -->
      <div class="row">
        <div class="container searchBox">
          <div class="row">
            <div class="col-sm-12" :style="{ fontSize: fonts.font24 + 'px' }">
              Search Parameters</div>
          </div>

          <!--Search Parameters Box - Includes searchLeft(amounts)/searchRight(categories)-->
          <div class="row">
                <!-- SearchLeft Text/Amount box -->
                <div class="col-md-6 searchLeft">
                  <div class="row">
                    <b-form-checkbox class="seCheckBox"
                                     ref="seCheck"
                                     v-model="stChecked"
                                     :style="{ fontSize: fonts.font12 + 'px' }">
                      Search for the following text (partial word ok):
                    </b-form-checkbox>
                  </div>

                  <div class="row">
                      <b-form-input id="sText"
                                    autocomplete="off"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    spellcheck="true"
                                    class="clText"
                                    aria-label="Enter Search Text"
                                    type="text"
                                    @change="textSearchChanged"
                                    v-model="searchText"
                                    placeholder="Enter Search Text">
                      </b-form-input>
                  </div>

                  <div class="row">
                      <b-form-select
                        v-model="selectedDollar"
                        :options="optionsDollar"
                        @change="customizeDollar"
                        class="dropDollarRange">
                      </b-form-select>
                  </div>

                  <div v-if="rangeForm === '1'" class="row">
                    <table class="col-sm-6 container dollarGroup">
                      <th>Min Dollar</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="minDollar"
                            @change="minDollarChanged"
                            placeholder="Minimum">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>

                    <table class="col-sm-6 container dollarGroup">
                      <th>Max Dollar</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="maxDollar"
                            @change="maxDollarChanged"
                            placeholder="Maximum">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div v-if="rangeForm === '2'" class="row">
                    <table class="col-sm-6 container dollarGroup">
                      <th>Exact Amount</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="exDollar"
                            @change="exDollarChanged"
                            placeholder="Exact Dollar">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div v-if="rangeForm === '3'" class="row">
                    <table class="col-sm-6 container dollarGroup">
                      <th>Min Check #</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="minCheck"
                            @change="minCheckChanged"
                            placeholder="Minimum">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>

                    <table class="col-sm-6 container dollarGroup">
                      <th>Max Check #</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="maxCheck"
                            @change="maxCheckChanged"
                            placeholder="Maximum">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div v-if="rangeForm === '4'" class="row">
                    <table class="col-sm-6 container dollarGroup">
                      <th>Exact Check Number</th>
                      <tr>
                        <td>
                          <b-form-input
                            class="dollarInput"
                            v-model="exCheck"
                            @change="exCheckChanged"
                            placeholder="Exact Check Number">
                          </b-form-input>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <!-- ********************************************************
                SearchRight - Category List Box
                ********************************************************* -->
                <div class="col-md-6 searchRight">
                  <table class="catBox">
                    <thead>
                    <th colspan="2">Category List</th>
                    </thead>

                    <tbody>
                    <tr>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.dft">Checks/Drafts</el-checkbox>
                      </td>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.xfr">Transfers</el-checkbox>
                      </td>
                    </tr>

                    <tr>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.ach">ACH Items</el-checkbox>
                      </td>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.fee">Fees</el-checkbox>
                      </td>
                    </tr>

                    <tr>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.pos">POS Items</el-checkbox>
                      </td>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.pay">Loan Payments</el-checkbox>
                      </td>
                    </tr>

                    <tr>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.atm">ATM Items</el-checkbox>
                      </td>
                      <td class="catCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.adv">Loan Advance</el-checkbox>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2" class="catWideCell">
                        <el-checkbox
                          class="chkBox"
                          @change="validateRestrict"
                          v-model="chkBox.oth">All categories NOT listed above</el-checkbox>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2" class="catWideCell">
                        <el-checkbox
                          class="chkBox"
                          @change="setRestrict"
                          v-model="chkBox.noRestrict">Don't Restrict by Category</el-checkbox>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
          </div>
          <div style="height: 10px;"></div>
        </div>
      </div>

      <!-- ********************************************************
      Bottom Buttons
      ********************************************************* -->
      <div class="row">
        <div class="col-md-12" v-if="askSaveName === false">
          <button
            class="btn btn-success lowBtn"
            @click="clkSearch"
            type="button">Search</button>
          <button
            class="btn btn-danger lowBtn"
            @click="cancel"
            type="button">Cancel</button>
          <button
            class="btn btn-primary lowBtn"
            @click="saveSearch"
            type="button">Save</button>
          <button
            class="btn btn-primary lowBtn"
            @click="recallSavesList"
            type="button">Recall</button>
        </div>
        <div class="col-md-12 saveBox" v-if="askSaveName === true">
          <div :style="{ fontSize: fonts.font24 + 'px' }">Save Search Parameters</div>
          <div :style="{ fontSize: fonts.font12 + 'px' }">
            Select parameters above then enter a name to save as.</div>
          <b-form-input id="snText"
                        name="snText"
                        ref="snText"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="true"
                        class="clText"
                        aria-label="Enter Save Name"
                        type="text"
                        v-model="saveName"
                        placeholder="Enter Save Name">
          </b-form-input>
          <button
            class="btn btn-success lowBtn"
            @click="saveSearch"
            type="button">Save</button>
          <button
            class="btn btn-danger lowBtn"
            @click="cancelSearch"
            type="button">Cancel</button>
        </div>
      </div>
    </div> <!-- End of Normal Form -->

    <!-- Start of Save List -->
    <div v-if="showSaveList === true" :style="{ fontSize: fonts.font18 + 'px' }">
      <span v-if="ssListLength > 0">Select Saved search Item or click Remove</span>
      <span v-if="ssListLength === 0">You've not saved any searches yet</span>
      <div>
        <div v-for="ss in ssList" :key="ss.key">
          <div>
            <div>
              <div class="groupSection">
                <div class="ssLine">
                  <div class="ssDesc"
                       @click="recallSavedSearch(ss)"
                       v-html="ss.desc"></div>
                  <b-button v-if="ss.key !== 'svs- Top'" class="bg4Del"
                            @click="removeSS(ss)">
                    Remove
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="btn btn-success lowBtn"
        @click="closeSearchList"
        type="button">Close</button>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
// const moment = require('moment');

export default {
  name: 'search',
  data() {
    return {
      showSaveList: false,
      askSaveName: false,
      domUpdated: false,
      saveName: '',
      direction: 'rev',
      rangeForm: '1',
      searchOpt: 1,
      startDate: '',
      endDate: '',
      tCount: '21',
      stChecked: false,
      searchText: '',
      loAmount: 0,
      hiAmount: 0,
      colorOn: 'green',
      colorOff: 'transparent',
      tqColor: 'green',
      drColor: 'transparent',
      chkBox: {
        dft: false,
        ach: false,
        pos: false,
        atm: false,
        xfr: false,
        fee: false,
        pay: false,
        adv: false,
        oth: false,
        noRestrict: true,
      },
      stCheck: false,
      selected: 'cdr',
      options: [
        { value: 'cdr', text: 'Custom Date Range' },
        { value: '1d', text: 'Today Only' },
        { value: '1w', text: 'Most Recent 7 Days' },
        { value: '2w', text: 'Most Recent 14 Days' },
        { value: 'cm', text: 'This Current Month' },
        { value: 'r2', text: 'Most Recent Two Months' },
        { value: 'r3', text: 'Most Recent Three Months' },
        { value: 'pm', text: 'Prior Month' },
        { value: '2m', text: 'Two Months Ago' },
        { value: '3m', text: 'Three Months Ago' },
        { value: 'cy', text: 'Current Year' },
        { value: 'py', text: 'Prior Year' },
        { value: '2y', text: 'Two Years Ago' },
      ],
      selectedDollar: 'at',
      optionsDollar: [
        { value: 'cdr', text: 'Custom Dollar Range' },
        { value: 'at', text: 'Full Dollar Range' },
        { value: 'od', text: 'Only Deposits' },
        { value: 'ow', text: 'Only Withdrawals' },
        { value: 'ex', text: 'Exact Dollar Amount' },
        { value: 'ck', text: 'Check Number Range' },
        { value: 'cx', text: 'Exact Check Number' },
      ],
      minDollar: '-1,000,000.00',
      maxDollar: '1,000,000.00',
      exDollar: '',
      minCheck: '1',
      maxCheck: '99999',
      exCheck: '',
    };
  },
  watch: {
    tCount() {
      if (this.tCount !== 'N/A') {
        this.tcChanged();
      }
    },
    askSaveName() {
      if (this.askSaveName === true) {
        this.domUpdated = false; // Clear so updated() can update it
      } else {
        this.domUpdated = false; // Clear because askSaveName is not shown anymore
      }
    },
  },
  computed: {
    ssListLength() {
      return Object.keys(this.ssList).length;
    },
    ssList() {
      return this.$store.getters.getSavedSearchList;
    },
    quickRange() {
      return this.$store.getters.getSearchRange;
    },
    history() {
      return this.$store.getters.getHistory;
    },
    histShares() {
      return this.$store.getters.getHistShares;
    },
    histLoans() {
      return this.$store.getters.getHistLoans;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    searchHead() {
      return `Search ${this.member.acct}-${this.history.desc}`;
    },
    trHigh() {
      return this.$store.getters.getTrHigh;
    },
  },
  methods: {
    clkSearch() {
      // utl.diag('Clicked Search');
      if (this.tCount < 1) this.tCount = 1;
      if (this.tCount > 10000) this.tCount = 10000;
      const ahInfo = {};
      ahInfo.cun = this.cun;
      ahInfo.acct = this.member.acct;
      ahInfo.type = this.history.type;
      ahInfo.share = this.history.share;
      ahInfo.quan = this.tCount;
      ahInfo.maxTr = this.trHigh;
      ahInfo.option = 0;
      ahInfo.note = this.history.note;
      ahInfo.loDate = utl.pakDate(this.startDate);
      ahInfo.hiDate = utl.pakDate(this.endDate);
      ahInfo.loDraft = 0;
      ahInfo.hiDraft = 0;
      this.loAmount = parseInt(utl.stripDollar(this.minDollar), 10) * 100;
      this.hiAmount = parseInt(utl.stripDollar(this.maxDollar), 10) * 100;
      ahInfo.loAmt = this.loAmount;
      ahInfo.hiAmt = this.hiAmount;
      ahInfo.srch = this.searchText;
      if (this.selectedDollar === 'ck') {
        ahInfo.loDraft = this.minCheck;
        ahInfo.hiDraft = this.maxCheck;
      } else {
        ahInfo.loDraft = 0;
        ahInfo.hiDraft = 0;
      }
      if (this.chkBox.dft === true) { ahInfo.chk = 'Y'; } else { ahInfo.chk = 'N'; }
      if (this.chkBox.ach === true) { ahInfo.ach = 'Y'; } else { ahInfo.ach = 'N'; }
      if (this.chkBox.pos === true) { ahInfo.pos = 'Y'; } else { ahInfo.pos = 'N'; }
      if (this.chkBox.atm === true) { ahInfo.atm = 'Y'; } else { ahInfo.atm = 'N'; }
      if (this.chkBox.xfr === true) { ahInfo.xfr = 'Y'; } else { ahInfo.xfr = 'N'; }
      if (this.chkBox.fee === true) { ahInfo.fee = 'Y'; } else { ahInfo.fee = 'N'; }
      if (this.chkBox.pay === true) { ahInfo.pay = 'Y'; } else { ahInfo.pay = 'N'; }
      if (this.chkBox.adv === true) { ahInfo.adv = 'Y'; } else { ahInfo.adv = 'N'; }
      if (this.chkBox.oth === true) { ahInfo.oth = 'Y'; } else { ahInfo.oth = 'N'; }
      if (this.chkBox.noRestrict === false) { ahInfo.restrict = 'Y'; } else { ahInfo.restrict = 'N'; }
      const pkOpt = utl.packSearchOptions(this.chkBox);
      utl.diag(`pkOpt = ${pkOpt}`);
      ahInfo.direction = this.direction; // Handled locally by store
      ahInfo.fill = '';
      ahInfo.desc = this.history.desc;
      this.$store.commit('initHist', ahInfo);
      window.history.back();
    },
    cancel() {
      // utl.diag('Clicked Cancel');
      window.history.back();
    },
    saveSearch() {
      if (this.askSaveName === false) {
        this.askSaveName = true;
        return;
      }
      const saveName = utl.restrictToChars(this.saveName, /[a-z]|[A-Z]|[0-9]| |-|$/).trim();
      if (saveName.length === 0) {
        this.showAlert('Please Enter a valid Save-Name');
        return;
      }
      const key = `svs-${saveName.replace(/ /g, '_')}`;
      utl.diag(key);
      const svInfo = {};
      svInfo.cats = utl.packSearchOptions(this.chkBox);
      // utl.diag(`svInfo.pkOpt = ${svInfo.cats}`);
      svInfo.direction = this.direction;
      svInfo.quan = this.tCount;
      svInfo.dateRange = this.selected;
      if ((this.selected === 'cdr') && (this.tCount === 'N/A')) {
        svInfo.loDate = utl.pakDate(this.startDate);
        svInfo.hiDate = utl.pakDate(this.endDate);
      }
      if (this.stChecked === true) {
        svInfo.stChecked = true;
        svInfo.searchText = this.searchText;
      }
      svInfo.dollarRange = this.selectedDollar;
      if (this.selectedDollar === 'ck') {
        svInfo.loDraft = this.minCheck;
        svInfo.hiDraft = this.maxCheck;
      }
      if (this.selectedDollar === 'cx') {
        svInfo.loDraft = this.minCheck;
      }
      if (this.selectedDollar === 'cdr') {
        svInfo.loAmt = parseInt(utl.stripDollar(this.minDollar), 10) * 100;
        svInfo.hiAmt = parseInt(utl.stripDollar(this.maxDollar), 10) * 100;
      }
      if (this.selectedDollar === 'ex') {
        this.loAmount = parseInt(utl.stripDollar(this.minDollar), 10) * 100;
        svInfo.loAmt = this.loAmount;
      }
      const data = JSON.stringify(svInfo);
      const svData = {};
      svData.data = data;
      svData.key = key;
      this.$store.commit('saveSearch', svData);
      // localStorage.setItem(key, data);
      this.askSaveName = false;
    },
    cancelSearch() {
      this.askSaveName = false;
    },
    recallSavesList() {
      this.$store.commit('updateSearchList');
      const ssLength = Object.keys(this.ssList).length;
      let ssList;
      // let svInfo;
      utl.diag(`recallSavesList() - arrayLength=${ssLength}`);
      for (let i = 1; i < ssLength; i += 1) {
        ssList = this.ssList[i];
        // svInfo = JSON.parse(ssList.data);
        // svInfo = ssList.data; // Already JSON.parse() in updateSearchList
        utl.diag(`${ssList.key} ${ssList.data.quan}`);
      }
      this.showSaveList = true;
    },
    recallSavedSearch(ss) {
      utl.diag(`Clicked ${ss.key}`);
      this.askSaveName = false;
      const svInfo = ss.data;
      this.saveName = ss.desc;
      this.chkBox = utl.unpackSearchOptions(svInfo.cats);
      this.direction = svInfo.direction;
      this.tCount = svInfo.quan;

      this.selected = svInfo.dateRange;
      if (this.tCount === 'N/A') {
        this.customize(this.selected);
        if (this.selected === 'cdr') {
          if (typeof svInfo.loDate !== 'undefined') {
            this.startDate = utl.unpakDate(svInfo.loDate);
          }
          if (typeof svInfo.hiDate !== 'undefined') {
            this.endDate = utl.unpakDate(svInfo.hiDate);
          }
        }
      }

      this.selectedDollar = svInfo.dollarRange;
      this.customizeDollar(this.selectedDollar);

      if (typeof svInfo.searchText !== 'undefined') {
        this.stChecked = true;
        this.searchText = svInfo.searchText;
      }


      /*
      if ((this.selected === 'cdr') && (this.tCount === 'N/A')) {
        svInfo.loDate = utl.pakDate(this.startDate);
        svInfo.hiDate = utl.pakDate(this.endDate);
      }
      if (this.stChecked === true) {
        svInfo.stChecked = true;
        svInfo.searchText = this.searchText;
      }
      if (this.selectedDollar === 'ck') {
        svInfo.loDraft = this.minCheck;
        svInfo.hiDraft = this.maxCheck;
      }
      if (this.selectedDollar === 'cx') {
        svInfo.loDraft = this.minCheck;
      }
      if (this.selectedDollar === 'cdr') {
        svInfo.loAmt = parseInt(utl.stripDollar(this.minDollar), 10) * 100;
        svInfo.hiAmt = parseInt(utl.stripDollar(this.maxDollar), 10) * 100;
      }
      if (this.selectedDollar === 'ex') {
        this.loAmount = parseInt(utl.stripDollar(this.minDollar), 10) * 100;
        svInfo.loAmt = this.loAmount;
      }
      */
      this.showSaveList = false;
    },
    removeSS(ss) {
      utl.diag(`Remove ${ss.key}`);
      this.$store.commit('removeSavedSearch', ss.key);
    },
    closeSearchList() {
      this.showSaveList = false;
    },
    tcGotFocus() {
      // utl.diag('tCount Got Focus');
      if (this.tCount === 'N/A') {
        this.tCount = '21';
      }
    },
    tcChanged() {
      this.searchOpt = 1;
      this.tqColor = this.colorOn;
      this.drColor = this.colorOff;
      this.selected = 'cdr';
      this.startDate = '';
      this.endDate = '';
    },
    oldChanged() {
      this.searchOpt = 2;
      this.tCount = 'N/A';
      this.tqColor = this.colorOff;
      this.drColor = this.colorOn;
      this.selected = 'cdr';
      if (this.endDate.length === 0) this.endDate = this.startDate;
      if (this.endDate < this.startDate) this.endDate = this.startDate;
    },
    newChanged() {
      this.searchOpt = 2;
      this.tCount = 'N/A';
      this.tqColor = this.colorOff;
      this.drColor = this.colorOn;
      this.selected = 'cdr';
      if (this.startDate.length === 0) this.startDate = this.endDate;
      if (this.startDate > this.endDate) this.startDate = this.endDate;
    },
    customize(value) {
      this.searchOpt = 2;
      this.tCount = 'N/A';
      this.tqColor = this.colorOff;
      this.drColor = this.colorOn;
      // utl.diag(`Pre-defined Changed = ${value}`);
      const dateRange = utl.getDateRange(value);
      this.startDate = dateRange.startDate;
      this.endDate = dateRange.endDate;
    },
    validateRestrict() {
      let test = true;
      if (this.chkBox.dft === true) { test = false; }
      if (this.chkBox.ach === true) { test = false; }
      if (this.chkBox.pos === true) { test = false; }
      if (this.chkBox.atm === true) { test = false; }
      if (this.chkBox.xfr === true) { test = false; }
      if (this.chkBox.fee === true) { test = false; }
      if (this.chkBox.pay === true) { test = false; }
      if (this.chkBox.adv === true) { test = false; }
      if (this.chkBox.oth === true) { test = false; }
      this.chkBox.noRestrict = test;
    },
    setRestrict() {
      if (this.chkBox.noRestrict === true) {
        this.chkBox.dft = false;
        this.chkBox.ach = false;
        this.chkBox.pos = false;
        this.chkBox.atm = false;
        this.chkBox.xfr = false;
        this.chkBox.fee = false;
        this.chkBox.pay = false;
        this.chkBox.adv = false;
        this.chkBox.oth = false;
      }
    },
    textSearchChanged() {
      const tLen = this.searchText.trim().length;
      this.stChecked = tLen > 0;
    },
    customizeDollar(value) {
      const rv = utl.customizeDollar(value);
      utl.diag(rv);
      this.rangeForm = rv.rangeForm;
      if (rv.rangeForm === '1') {
        this.minDollar = rv.minDollar;
        this.maxDollar = rv.maxDollar;
      }
      if (value === 'ex') {
        this.rangeForm = '2';
      } else {
        this.exDollar = '';
      }
      if (value === 'ck') {
        this.rangeForm = '3';
      }
      if (value === 'cx') {
        this.rangeForm = '4';
      } else {
        this.exCheck = '';
      }
    },
    minDollarChanged() {
      this.selectedDollar = 'cdr';
      this.minDollar = utl.stripDollar(this.minDollar);
      this.minDollar = utl.fmtDollar(this.minDollar * 100).trim();
    },
    maxDollarChanged() {
      this.selectedDollar = 'cdr';
      this.maxDollar = utl.stripDollar(this.maxDollar);
      this.maxDollar = utl.fmtDollar(this.maxDollar * 100).trim();
    },
    exDollarChanged() {
      this.exDollar = utl.stripDollar(this.exDollar);
      this.exDollar = utl.fmtDollar(this.exDollar * 100).trim();
      this.minDollar = this.exDollar;
      this.maxDollar = this.exDollar;
      this.selectedDollar = 'cdr';
      this.rangeForm = '1';
    },
    minCheckChanged() {
      this.selectedDollar = 'ck';
      this.minCheck = utl.stripCheck(this.minCheck);
    },
    maxCheckChanged() {
      this.selectedDollar = 'ck';
      this.maxCheck = utl.stripCheck(this.maxCheck);
    },
    exCheckChanged() {
      this.exCheck = utl.stripCheck(this.exCheck);
      this.minCheck = this.exCheck;
      this.maxCheck = this.exCheck;
      this.selectedDollar = 'ck';
      this.rangeForm = '3';
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    // eslint-disable-next-line
    handleKeyStroke(event) {
      let keyCode = event.keyCode;
      const e1 = document.activeElement;
      if (keyCode === 13) { // Enter Pressed
        keyCode = 0;
        event.preventDefault();
        event.stopPropagation(true);
        if (e1.name === 'snText') this.saveSearch();
      }
    },
  },
  updated() {
    if ((this.askSaveName === true) && (this.domUpdated === false)) {
      this.domUpdated = true;
      utl.scrollToBottom();
      this.$refs.snText.focus();
    }
  },
  created() {
    window.addEventListener('keypress', this.handleKeyStroke);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleKeyStroke);
  },
};
</script>

<style scoped>
  .acctTitle {
    text-align: center;
  }
  .topBox {
    border: solid 1px black;
  }
  #recentCount {
    margin-left: 8px;
    margin-right: 8px;
    width: 50px;
    text-align: center;
  }
  .searchBox {
    border: solid 1px black;
  }
  .searchLeft {
    /* border: solid 1px red; */
  }
  .searchRight {
    /* border: solid 1px green; */
  }
  .dateHeader {
    /* border: solid 1px black; */
  }
  .datePicker {
    width: 200px;
  }
  .catBox {
    width: 298px;
    alignment: left;
  }
  .dropper {
    text-align: center;
  }
  .dollarGroup {
    /* border: dotted 1px black; */
    horiz-align: center;
    width: 200px;
  }
  .dollarInput {
    text-align: center;
    width: 198px;
  }
  .chkBox {
    font-weight: bold;
  }
  .catCell {
    /* border: dotted 1px black; */
    width: 148px;
    padding-left: 8px;
    text-align: left;
  }
  .catWideCell {
    /* border: dotted 1px black; */
    width: 296px;
    padding-left: 8px;
    text-align: left;
  }
  .lowBtn {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .saveBox {
    border: solid 1px black;
  }
  #snText {
    /* width: 300px; */
  }
  .dropx {
    width: 250px;
    margin: auto;
  }
  .rGroup {
    position: relative;
    display: block;
    /* border: solid 2px black; */
    width: fit-content;
    margin: auto;
    text-align: left;
    padding-left: 24px;
  }
  .rItem {
    padding-left: 4px;
    text-align: left;
  }
  .ssLine {
    width: 300px;
    display: flex;
    text-wrap: avoid;
    text-align: left;
    /* vertical-align: middle;*/
    margin: auto;
    padding: 0px 0px 0px 8px;
    height: 40px;
    background-color: transparent;
    font-weight: bold;
    border: solid 2px black;
    cursor: pointer;
  }
  .ssDesc {
    font-size: 12px;
    width: 214px;
    text-wrap: avoid;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-top: 6px;
  }
  .bg4Del { /* Delete button on each CU Line */
    font-size: 12px;
    background-color: red;
    margin: auto;
    color: black;
  }


</style>



// WEBPACK FOOTER //
// src/components/p05-search.vue